import { SalaryScaleGroupService, ISalaryScaleGroup } from "../../../services/salaryScaleGroup.service";

class TimezonesListController implements ng.IComponentController {
    sortType: string;
    salaryScaleGroups: ISalaryScaleGroup[];
    selectedGroup: ISalaryScaleGroup;

    private weekDays = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];

    constructor(
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';

        this.sortType = 'from';
    }

    public $onInit = () => {
        this.loadSalaryScaleGroups();
    }

    private loadSalaryScaleGroups = () => {
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            // Sort alphabetically by name
            this.salaryScaleGroups = result.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
            
            // Restore selectedGroup from state params if available
            const selectedGroupId = this.$stateParams['selectedCaoId'];
            if (selectedGroupId) {
                const group = this.salaryScaleGroups.find(g => g.id === selectedGroupId);
                if (group) {
                    this.selectedGroup = group;
                }
            } else if (this.selectedGroup) {
                // Update selectedGroup als die nog bestaat
                const updatedGroup = this.salaryScaleGroups.find(g => g.id === this.selectedGroup.id);
                if (updatedGroup) {
                    this.selectedGroup = updatedGroup;
                }
            }
        });
    }

    public clearSelection = () => {
        this.selectedGroup = null;
        // Clear selected CAO ID from state params
        this.$state.go('settings.timezones.list', { 'selectedCaoId': null }, { location: 'replace', notify: false });
    }

    public onGroupChange = (selectedGroup: ISalaryScaleGroup) => {
        this.selectedGroup = selectedGroup;
        // Save selected CAO ID to state params
        this.$state.go('settings.timezones.list', { 'selectedCaoId': selectedGroup ? selectedGroup.id : null }, { location: 'replace', notify: false });
    }

    public addTimezone = () => {
        if (!this.selectedGroup || !this.selectedGroup.id) {
            alert('Geen CAO geselecteerd. Selecteer eerst een CAO om een timezone toe te voegen.');
            return;
        }
        this.$state.go('settings.timezones.list.item', { 'id': '', 'caoId': this.selectedGroup.id });
    }

    public caoFilter = (item: any) => {
        if (!this.selectedGroup || !this.selectedGroup.id) {
            return false;
        }
        return item.salaryScaleGroupId === this.selectedGroup.id;
    }
}

export const timezonesListComponent: ng.IComponentOptions = {
    controller: TimezonesListController,
    bindings: {
        timezones:'<'
    },
    template: require('./timezones.list.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/settings/timezones/timezones.list.component.ts